import React, { FC, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useBreakpoints } from 'common/hooks/use-breakpoints';
import { useSelector } from 'react-redux';
import { getPlankLink } from 'features/store/ducks/get-store-by-id';
import { getTitle } from 'features/page-model/ducks/get-model';
import { analyticsUtils } from 'utils';
import { RoundedLink } from '../rounded-link';
import { StorePlanModal } from '../store-plan-modal';
import { StoreGeneralPlanImage } from '../store-general-plan-image';
import { imageContainer, roundedLink } from './styles';

export const DATA_QA_SHOP_PLAN = 'shop-plan';

export const StorePlan: FC = () => {
  const { t } = useTranslation();
  const { smMobile, mobile } = useBreakpoints() ?? {};
  const [open, setOpen] = useState(false);
  const planLink = useSelector(getPlankLink) || '';
  const title = useSelector(getTitle);
  const shopPlan = t('shopPlan');
  const close = t('ui.close');

  const handleOpen = useCallback(() => {
    setOpen(true);
    analyticsUtils.sendEvent('GA:clickButton', {
      elementType: 'button',
      elementBlock: 'shopPage', // блок, в котором расположен элемент
      elementName: title, // название блока
      elementText: shopPlan, // текст кнопки (Как добраться транспортом, Товары в магазине, План магазина, Фото магазина)
    });
  }, [title, shopPlan]);

  const handleClose = useCallback(() => {
    setOpen(false);
    analyticsUtils.sendEvent('GA:clickButton', {
      elementType: 'button',
      elementBlock: 'shopPage', // блок, в котором расположен элемент
      elementName: `${title} / ${shopPlan}`, // название блока
      elementText: close, // текст кнопки (Как добраться транспортом, Товары в магазине, План магазина, Фото магазина)
    });
  }, [title, shopPlan, close]);

  return (
    <div>
      {!mobile && !smMobile && planLink && (
        <RoundedLink
          testId={DATA_QA_SHOP_PLAN}
          title={shopPlan}
          onClick={handleOpen}
          className={roundedLink}
          description={t('shopPlanDescription')}
        >
          <div className={imageContainer}>
            <StoreGeneralPlanImage />
          </div>
        </RoundedLink>
      )}
      <StorePlanModal imageUrl={planLink} onClose={handleClose} show={open} />
    </div>
  );
};
